export const questions = [
  {
    name: "Classroom rules placed and followed",
    key: "classroomRules",
    category: "displays",
  },

  {
    name: "Newspaper reading time is effectively utilised",
    key: "newsUpdate",
    category: "activities",
  },

  { name: "Smiley Chart updated", key: "smileyChart", category: "displays" },

  {
    name: "Mission English Chart updated",
    key: "missionEnglishChart",
    category: "displays",
  },

  {
    name: "Birthday Chart put up with name and dates",
    key: "birthdayChart",
    category: "displays",
  },

  {
    name: "Transport Corner updated",
    key: "transportCorner",
    category: "displays",
  },

  {
    name: "Participation Chart being updated",
    key: "participationChart",
    category: "displays",
  },

  {
    name: "Club list & House list put up",
    key: "clubHouseList",
    category: "displays",
  },

  { name: "DEAR period observed", key: "dearPeriod", category: "activities" },

  {
    name: "Children in proper uniform along with I.Card",
    key: "uniformTieBeltShoesICard",
    category: "student",
  },

  { name: "Class Pass – 2 available", key: "classPass", category: "admin" },

  {
    name: "Class & Teacher's Timetable updated",
    key: "classTeacherTimeTable",
    category: "admin",
  },

  {
    name: "Lunch Etiquettes being followed",
    key: "lunchEtiquettes",
    category: "activities",
  },

  {
    name: "Thursday Special being followed",
    key: "thursdaySpecial",
    category: "activities",
  },

  {
    name: "Goodwill Piggy Bank opened weekly & no. of chits",
    key: "goodwillPiggyBank",
    category: "student",
  },

  {
    name: "Group/Team on Duty put up along with names of Eco Champions and Empathy Managers",
    key: "isGroupOnDuty",
    category: "student",
  },

  {
    name: "Weekly Rotation of Students done",
    key: "isWeeklyRotationOfStudents",
    category: "student",
  },

  {
    name: "Anecdotal Register maintained",
    key: "anecdotalRegister",
    category: "admin",
  },

  {
    name: "Supplementary Reading Record marked",
    key: "supplementaryReadingRecord",
    category: "admin",
  },

  {
    name: "Think Zone questions being updated regularly",
    key: "thinkZone",
    category: "displays",
  },

  {
    name: "Digital citizenship rules displayed",
    key: "digitalCitizenshipRules",
    category: "displays",
  },

  {
    name: "Guided meditation session being conducted",
    key: "meditation",
    category: "activities",
  },

  {
    name: "Electronic devices being responsibly used",
    key: "electronicDevices",
    category: "technology",
  },

  {
    name: "Is the segregation at source happening: E-waste, paper waste and plastic waste?",
    key: "wasteSegregation",
    category: "sustainability",
  },

  {
    name: "Is the class contributing E-waste, plastic waste and paper waste regularly?",
    key: "wasteContribution",
    category: "sustainability",
  },

  {
    name: "Are all the boxes labelled and placed in accessible location in the classroom?",
    key: "wasteBoxesLabelled",
    category: "sustainability",
  },

  {
    name: "Are all students aware of the purpose and contributing wisely?",
    key: "wasteAwareness",
    category: "sustainability",
  },

  {
    name: "Are all students following cleanliness rules?",
    key: "studentCleanliness",
    category: "environment",
  },

  {
    name: "Are fans, lights, and switches clean and functional?",
    key: "electricalFixtures",
    category: "environment",
  },

  {
    name: "Is the ambience of classroom looking welcoming?",
    key: "classCleanliness",
    category: "environment",
  },

  {
    name: "Are all the charts and posters pasted neatly and properly?",
    key: "chartsPosters",
    category: "environment",
  },

  {
    name: "Is all the furniture clean and in good condition?",
    key: "furnitureCondition",
    category: "environment",
  },

  {
    name: "Are all the boxes being used wisely and emptied regularly?",
    key: "wasteBoxesMaintenance",
    category: "sustainability",
  },

  {
    name: "Are the anecdotes being recorded with good quality and updated in a timely manner?",
    key: "anecdotalQuality",
    category: "admin",
  },

  {
    name: "Are PTM records updated timely on Edunext?",
    key: "ptmRecords",
    category: "admin",
  },
];
export const questions2 = [
  {
    name: "Classroom rules placed and followed",
    key: "classroomRules",
    category: "displays",
  },

  {
    name: "Newspaper reading time is effectively utilised",
    key: "newsUpdate",
    category: "activities",
  },

  { name: "Smiley Chart updated", key: "smileyChart", category: "displays" },

  {
    name: "Mission English Chart updated",
    key: "missionEnglishChart",
    category: "displays",
  },

  {
    name: "Birthday Chart put up with name and dates",
    key: "birthdayChart",
    category: "displays",
  },

  {
    name: "Transport Corner updated",
    key: "transportCorner",
    category: "displays",
  },

  {
    name: "Participation Chart being updated",
    key: "participationChart",
    category: "displays",
  },

  {
    name: "Club list & House list put up",
    key: "clubHouseList",
    category: "displays",
  },

  { name: "DEAR period observed", key: "dearPeriod", category: "activities" },

  {
    name: "Children in proper uniform along with I.Card ",
    key: "uniformTieBeltShoesICard",
    category: "student",
  },

  { name: "Class Pass – 2 available", key: "classPass", category: "admin" },

  {
    name: "Class & Teacher's Timetable updated",
    key: "classTeacherTimeTable",
    category: "admin",
  },

  {
    name: "Lunch Etiquettes being followed",
    key: "lunchEtiquettes",
    category: "activities",
  },

  {
    name: "Thursday Special being followed",
    key: "thursdaySpecial",
    category: "activities",
  },

  {
    name: "Goodwill Piggy Bank opened weekly & no. of chits",
    key: "goodwillPiggyBank",
    category: "student",
  },

  {
    name: "Group/Team on Duty put up along with names of Eco Champions and Empathy Managers",
    key: "isGroupOnDuty",
    category: "student",
  },

  {
    name: "Weekly Rotation of Students done",
    key: "isWeeklyRotationOfStudents",
    category: "student",
  },

  {
    name: "Anecdotal Register maintained",
    key: "anecdotalRegister",
    category: "admin",
  },

  {
    name: "Supplementary Reading Record marked",
    key: "supplementaryReadingRecord",
    category: "admin",
  },

  {
    name: "Think Zone questions being updated regularly",
    key: "thinkZone",
    category: "displays",
  },

  {
    name: "Digital citizenship rules displayed",
    key: "digitalCitizenshipRules",
    category: "displays",
  },

  {
    name: "Guided meditation session being conducted",
    key: "meditation",
    category: "activities",
  },

  {
    name: "Electronic devices being responsibly used",
    key: "electronicDevices",
    category: "technology",
  },

  {
    name: "Is the segregation at source happening: E-waste, paper waste and plastic waste?",
    key: "wasteSegregation",
    category: "sustainability",
  },

  {
    name: "Is the class contributing E-waste, plastic waste and paper waste regularly?",
    key: "wasteContribution",
    category: "sustainability",
  },

  {
    name: "Are all the boxes labelled and placed in accessible location in the classroom?",
    key: "wasteBoxesLabelled",
    category: "sustainability",
  },

  {
    name: "Are all students aware of the purpose and contributing wisely?",
    key: "wasteAwareness",
    category: "sustainability",
  },

  {
    name: "Are all students following cleanliness rules?",
    key: "studentCleanliness",
    category: "environment",
  },

  {
    name: "Are fans, lights, and switches clean and functional?",
    key: "electricalFixtures",
    category: "environment",
  },

  {
    name: "Is the ambience of classroom looking welcoming?",
    key: "classCleanliness",
    category: "environment",
  },

  {
    name: "Are all the charts and posters pasted neatly and properly?",
    key: "chartsPosters",
    category: "environment",
  },

  {
    name: "Is all the furniture clean and in good condition?",
    key: "furnitureCondition",
    category: "environment",
  },

  {
    name: "Are all the boxes being used wisely and emptied regularly?",
    key: "wasteBoxesMaintenance",
    category: "sustainability",
  },

  {
    name: "Are the anecdotes being recorded with good quality and updated in a timely manner?",
    key: "anecdotalQuality",
    category: "admin",
  },

  {
    name: "Are PTM records updated timely on Edunext?",
    key: "ptmRecords",
    category: "admin",
  },
];

export const questionsOld = [
  { name: "Class Cleanliness", key: "classCleanliness" },
  { name: "News Update", key: "newsUpdate" },
  { name: "Smiley Chart", key: "smileyChart" },
  { name: "Mission English Chart", key: "missionEnglishChart" },
  { name: "Transport Corner", key: "transportCorner" },
  { name: "General Discipline", key: "generalDiscipline" },
  { name: "Lunch Etiquettes", key: "lunchEtiquettes" },
  { name: "Birthday Chart", key: "birthdayChart" },
  { name: "Unit Syllabus Chart", key: "unitSyllabusChart" },
  { name: "Uniform-Tie, Belt, Shoes, I.Card", key: "uniformTieBeltShoesICard" },
  { name: "Class Pass", key: "classPass" },
  { name: "Class/Teacher's Time Table", key: "classTeacherTimeTable" },
  { name: "Participation Chart", key: "participationChart" },
  {
    name: "Co-scholastic Activity Chart (PA, PE, CA)",
    key: "coScholasticActivityChart",
  },
  { name: "Goodwill Piggy Bank", key: "goodwillPiggyBank" },
  { name: "Thursday Special", key: "thursdaySpecial" },
  {
    name: "Homework Register / AQAD Register",
    key: "homeworkRegisterAQADRegister",
  },
  { name: "Is there a Group on Duty", key: "isGroupOnDuty" },
  {
    name: "Is there weekly Rotation of Student",
    key: "isWeeklyRotationOfStudents",
  },
  { name: "Anecdotal Register", key: "anecdotalRegister" },
  { name: "Supplementary Reading Record", key: "supplementaryReadingRecord" },
  { name: "Think Zone", key: "thinkZone" },
  { name: "Digital citizenship rules", key: "digitalCitizenshipRules" },
  { name: "Meditation", key: "meditation" },
];

export const questionsOld2 = [
  { name: "Class Cleanliness", key: "classCleanliness" },
  { name: "News Update", key: "newsUpdate" },
  { name: "Smiley Chart", key: "smileyChart" },
  { name: "Mission English Chart", key: "missionEnglishChart" },
  { name: "Transport Corner", key: "transportCorner" },
  { name: "General Discipline", key: "generalDiscipline" },
  { name: "Lunch Etiquettes", key: "lunchEtiquettes" },
  { name: "Birthday Chart", key: "birthdayChart" },
  { name: "Unit Syllabus Chart", key: "unitSyllabusChart" },
  { name: "Uniform-Tie, Belt, Shoes, I.Card", key: "uniformTieBeltShoesICard" },
  { name: "Class Pass", key: "classPass" },
  { name: "Class/Teacher's Time Table", key: "classTeacherTimeTable" },
  { name: "Participation Chart", key: "participationChart" },
  {
    name: "Co-scholastic Activity Chart (PA, PE, CA)",
    key: "coScholasticActivityChart",
  },
  { name: "Goodwill Piggy Bank", key: "goodwillPiggyBank" },
  { name: "Thursday Special", key: "thursdaySpecial" },
  {
    name: "Homework Register / AQAD Register",
    key: "homeworkRegisterAQADRegister",
  },
  { name: "Is there a Group on Duty", key: "isGroupOnDuty" },
  {
    name: "Is there weekly Rotation of Student",
    key: "isWeeklyRotationOfStudents",
  },
  { name: "Anecdotal Register", key: "anecdotalRegister" },
  { name: "Supplementary Reading Record", key: "supplementaryReadingRecord" },
  { name: "Think Zone", key: "thinkZone" },
  { name: "Digital citizenship rules", key: "digitalCitizenshipRules" },
  { name: "Meditation", key: "meditation" },
];

export const cutoffDate = "2026-04-01T00:00:00.000Z";
